import { useMutation } from "@tanstack/react-query";
import {
  createManufacturerAPI,
  deleteManufacturerAPI,
  updateManufacturerAPI,
} from "./manufacturer.api";
import { handleNetworkError } from "@repo/ui/libs";

const useAddManufacturerMutation = () => {
  return useMutation({
    mutationFn: createManufacturerAPI,
    onError: handleNetworkError,
  });
};

const useUpdateManufacturerMutation = () => {
  return useMutation({
    mutationFn: updateManufacturerAPI,
    onError: handleNetworkError,
  });
};

const useDeleteManufacturerMutation = () => {
  return useMutation({
    mutationFn: deleteManufacturerAPI,
    onError: handleNetworkError,
  });
};

export {
  useAddManufacturerMutation,
  useUpdateManufacturerMutation,
  useDeleteManufacturerMutation,
};
